import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { Button, CartoAlertSeverity, DialogConfirmation } from '@carto/meridian-ds/components'

interface Props {
  onClose?: () => void
  onCancel?: () => void
  cancelButton?: ReactNode
  closeButton?: ReactNode
  cancelLabel?: string
  closeLabel?: string
  contentLabel?: string
  titleLabel?: string
  severity?: CartoAlertSeverity
  content?: ReactNode
}

function EditDialogConfirmation({
  onClose,
  onCancel,
  cancelLabel,
  cancelButton,
  closeButton,
  closeLabel,
  contentLabel,
  titleLabel,
  severity = 'warning',
  content
}: Props) {
  if (!onClose || !onCancel) {
    return null
  }

  return (
    <DialogConfirmation
      opened
      severity={severity}
      title={<FormattedMessage id={titleLabel || 'common.dialogConfirmation.title'} />}
      actions={
        <>
          {onCancel &&
            (cancelButton ? (
              cancelButton
            ) : (
              <Button onClick={onCancel}>
                <FormattedMessage id={cancelLabel || 'common.button.cancel'} />
              </Button>
            ))}
          {onClose &&
            (closeButton ? (
              closeButton
            ) : (
              <Button variant="contained" onClick={onClose}>
                <FormattedMessage id={closeLabel || 'common.dialogConfirmation.leave'} />
              </Button>
            ))}
        </>
      }
    >
      {content ? content : <FormattedMessage id={contentLabel || 'common.dialogConfirmation.content'} />}
    </DialogConfirmation>
  )
}

export default EditDialogConfirmation
